import { useQuery } from '@tanstack/react-query'
import { fetcher } from 'repositories/BerthApi/berthApiClient'
import { getBerthGroupsEndpoint } from 'repositories/BerthApi/getBerthGroups/endpoint'
import type { BerthGroup, GetBerthGroupsResponse } from 'repositories/BerthApi/getBerthGroups/type'
import { berthKeys } from 'repositories/queryKeys'

export type { BerthGroup }

export function useBerthGroups(tenantId: string | null) {
  const key = tenantId ? getBerthGroupsEndpoint(tenantId) : null

  const { data, error, isLoading } = useQuery<GetBerthGroupsResponse>({
    queryKey: berthKeys.group(tenantId ?? ''),
    queryFn: () => fetcher(key!),
    enabled: !!key,
  })

  return {
    berthGroups: data?.data?.berthGroups ?? [],
    totalPage: data?.data?.totalPage ?? 0,
    isLoading,
    error,
  }
}
